
import application from 'application/application';

// import angular from 'angular';

application

	.directive('infiniteScrollPage',['$timeout', function($timeout) {
		return {
			restrict: 'A',
			link: function(scope, element, attr) {
				var elm = $(document);
				let inUse = false;

				elm.on('wheel', function() {
					var porcentagem = (($(window).scrollTop() + window.innerHeight) / $(this).height()).toFixed(2);

					if (porcentagem >= 0.90 && !inUse) { //só aplica o scroll se for maior igual a 90%
						scope.$apply(attr.infiniteScrollPage);
						inUse= true;
						$timeout(() => inUse = false, 700);

					}
				});
			}
		};
	}]);


// application
// 	.directive('whenScrolled', function() {
// 		return {
// 			restrict: 'A',
// 			link: function(scope, elem, attrs) {

// 			// we get a list of elements of size 1 and need the first element
// 				var raw = elem[0];

// 				// we load more elements when scrolled past a limit
// 				elem.bind('scroll', function() {
// 					if (raw.scrollTop+raw.offsetHeight+5 >= raw.scrollHeight) {
// 						scope.loading = true;

// 						// we can give any function which loads more elements into the list
// 						scope.$apply(attrs.whenScrolled);
// 					}
// 				});
// 			}
// 		};
// 	});
